import { getTaskStatus } from '@/gen/clients/prompt-controller/getTaskStatus'
import { findPromptRewardByID } from '@/gen/clients/prompt-controller/findPromptRewardByID'
import type { GetTaskStatusQueryResponse, OverviewPromptResponse } from '@/gen/types'

type PromptTaskStatusWithError = GetTaskStatusQueryResponse & {
  errorMessage?: string
}

export const POLLING_CONFIG = {
  INTERVAL_MS: 2000,
  TIMEOUT_MS: 300000
} as const

export const isTerminalStatus = (status?: string): boolean =>
  status === 'FINISHED' || status === 'ERROR'

export async function waitForPromptCompletion(
  rewardId: string,
  signal?: AbortSignal
): Promise<OverviewPromptResponse> {
  const startTime = Date.now()

  while (Date.now() - startTime < POLLING_CONFIG.TIMEOUT_MS) {
    if (signal?.aborted) {
      throw new Error('Aborted')
    }

    const status = (await getTaskStatus(rewardId)) as PromptTaskStatusWithError

    if (status?.taskStatus === 'FINISHED' || !status) {
      return await findPromptRewardByID(rewardId)
    }

    if (status?.taskStatus === 'ERROR') {
      throw new Error(status.errorMessage || 'Prompt generation failed')
    }

    await new Promise(resolve => setTimeout(resolve, POLLING_CONFIG.INTERVAL_MS))
  }

  throw new Error('Prompt generation timeout')
}
